import React, {Component} from 'react';
import LocResourcesContext, {LocResourcesContextProps} from '../contexts/LocResourcesContext';
import gradient from "../../../common/src/assets/img/gradient.png";
import zooPoints from '../assets/img/zooPoints.svg';

const GLOBAL_PREFIX = "loy-bppo-giftBanner-box";

interface GiftBannerProps {
    giftAmount: number;
    giftStatus: boolean;
    showRewardShopButton: boolean;
}

interface GiftBannerStates {
    giftAmount: number;
    giftStatus: boolean;
    showRewardShopButton: boolean;
}


export default class GiftBanner extends Component<GiftBannerProps, GiftBannerStates> {
    private announcement: any;
    constructor(props: GiftBannerProps) {
        super(props);

        const {giftAmount, giftStatus, showRewardShopButton} = this.props;
        this.state = {
            giftAmount,
            giftStatus,
            showRewardShopButton,
        };
    }

    componentDidMount() {
        this.announcement = this.onFormatLocale("loy.bp.gift.announcement", {
            'points': this.state.giftAmount
        });
    }

    onFormatLocale (localeKey: string, params: any = undefined): string {
        return (this.context as LocResourcesContextProps).onFormatLocale(localeKey, params);
    }

    getGiftBannerWithoutPointsActive() {
        return <div className={`${GLOBAL_PREFIX}-withoutPointsActive`} data-grid-v3={"grid  gap-column-sm gap-row-xs gap-row-none@md " + (this.state.showRewardShopButton ? 'grid-rows-2@md grid-rows-3': 'grid-rows-2 grid-rows-2@md')}>

            <div data-grid-v3="col-start-1 col-7@md col-9 row-start-1 row-1"
                 className={`${GLOBAL_PREFIX}__points-withoutPointsActive`}
                 dangerouslySetInnerHTML={{__html: this.announcement}}>
            </div>
            <div data-grid-v3={"col-start-1 col-9 col-start-1@md row-start-2 row-1 " + (this.state.showRewardShopButton ? 'col-7@md': 'col-8@md')} className={`${GLOBAL_PREFIX}__subtitle v3-p2`}>
                {this.onFormatLocale("loy.bp.gift.announcement.subtitle")}
            </div>
            {this.state.showRewardShopButton &&
            <a href="/account/bonuspoints/products/overview"
               data-grid-v3="col-start-1 col-12 col-start-8@md col-3@md row-start-1@md row-2@md row-start-3 row-1"
               className={`${GLOBAL_PREFIX}__rewardShopButton v3-btn`}>
                {this.onFormatLocale("loy.rewardshop.link")}
            </a>}
            <div className={`${GLOBAL_PREFIX}__decoration`}>
                <img className={`${GLOBAL_PREFIX}__decoration--big-icon`}
                     src={zooPoints as any as string}/>
                <img className={`${GLOBAL_PREFIX}__decoration--small-icon`}
                     src={zooPoints as any as string}/>
                <img className={`${GLOBAL_PREFIX}__decoration--gradient`}
                     src={gradient}/>
            </div>
        </div>
    }

    getGiftBannerWithPointsActive() {
        return <div className={`${GLOBAL_PREFIX}-withPointsActive`}>
            <div className={`${GLOBAL_PREFIX}__decoration`}>
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M3.75 24a2.25 2.25 0 01-2.25-2.25V12A1.5 1.5 0 010 10.5V8.25A2.25 2.25 0 012.25 6l4.452.001C4.952 4.748 3.75 2.835 3.75.75A.75.75 0 014.5 0l.235.004C8.228.119 11.501 2.769 11.948 6h.104c.457-3.303 3.868-6 7.448-6l.102.007a.75.75 0 01.648.743c0 2.085-1.201 3.998-2.952 5.251L21.75 6A2.25 2.25 0 0124 8.25v2.25a1.5 1.5 0 01-1.5 1.5v9.75A2.25 2.25 0 0120.25 24zM9 12H3v9.75c0 .414.336.75.75.75H9V12zm4.5 0h-3v10.5h3V12zm7.5 0h-6v10.5h5.25a.75.75 0 00.743-.648L21 21.75V12zM9 7.5H2.25a.75.75 0 00-.75.75v2.25H9v-3zm4.5 0h-3v3h3v-3zm8.25 0H15v3h7.5V8.25a.75.75 0 00-.75-.75zM5.335 1.56l.035.157c.52 2.1 2.66 3.876 5.045 4.222-.45-2.167-2.637-4.023-5.08-4.378zm13.33.002l-.035.004c-2.429.367-4.597 2.217-5.045 4.372 2.443-.354 4.63-2.21 5.08-4.376z"
                        fill-rule="evenodd"/>
                </svg>
            </div>
            <div className={`${GLOBAL_PREFIX}__points-withPointsActive`}
                 dangerouslySetInnerHTML={{__html: this.announcement}}>
            </div>
        </div>
    }

    render() {
        return this.state.giftStatus ? this.getGiftBannerWithPointsActive() : this.getGiftBannerWithoutPointsActive();
    }
};
GiftBanner.contextType = LocResourcesContext as React.Context<LocResourcesContextProps>;
